export default __webpack_public_path__ + "static/media/watertoken192.e4d9e80d.png";